export enum CoreClientBlocksApiMetaTags {
  ClientBlocks = 'ClientBlocks',
}

export const coreClientBLocksApiMetaTagTypes = Object.values(CoreClientBlocksApiMetaTags);
